export const FLAG_GETTING_DRIVER_DOCUMENT_TYPES =
  'FLAG_GETTING_DRIVER_DOCUMENT_TYPES';
export const GET_DRIVER_DOCUMENT_TYPES = 'GET_DRIVER_DOCUMENT_TYPES';
export const CLEAR_DRIVER_DOCUMENT_TYPES = 'CLEAR_DRIVER_DOCUMENT_TYPES';
export const FLAG_DRIVER_DOCUMENT_TYPE_ACTIVITY =
  'FLAG_DRIVER_DOCUMENT_TYPE_ACTIVITY';
export const GET_DRIVER_DOCUMENT_TYPE = 'GET_DRIVER_DOCUMENT_TYPE';
export const CLEAR_DRIVER_DOCUMENT_TYPE = 'CLEAR_DRIVER_DOCUMENT_TYPE';
